import requestedScopes from "./scopes.json";

// A requested aggregate scope permits its documented members, not every key a
// provider happens to return. Unknown members fail closed in the display only;
// the original retrieved snapshot is preserved by businessPayload.
// Sources: Myinfo Business v3 Entity/Person OpenAPI and Corppass Auth Info /
// Third-party Auth Info / Standard Scopes (checked 19 October 2026).
const address = ["type", "block", "building", "country", "floor", "postal", "street", "unit"];
const assignment = ["CPEntID_SUB", "CPRole", "StartDate", "EndDate", "Parameter.name", "Parameter.value"];
const thirdPartyAssignment = ["CP_ClntEnt_SUB", "CPRole", "StartDate", "EndDate", "Parameter.name", "Parameter.value"];
export const groupedScopeFields = {
  "entity.address": [...address, "standard", "line1", "line2"],
  "user.regadd": [...address, "line1", "line2"],
  "user.hdbownership.address": address,
  "user.cpfcontributions": ["history.amount", "history.date", "history.employer", "history.month"],
  "user.cpfemployers": ["history.employer", "history.month"],
  "user.cpfhousingwithdrawal": [
    "withdrawaldetails.accruedinterestamt", "withdrawaldetails.monthlyinstalmentamt",
    "withdrawaldetails.principalwithdrawalamt", "withdrawaldetails.totalamountofcpfallowedforproperty",
    ...[...address, "line1", "line2"].map(key => `withdrawaldetails.address.${key}`),
  ],
  "user.noa": ["amount", "category", "employment", "interest", "rent", "taxclearance", "trade", "yearofassessment"],
  "entity.identity": ["entity_type", "entity_reg_number", "entity_coi"],
  authinfo: ["Result_Set.ESrvc_Row_Count", "Result_Set.ESrvc_Result.CPESrvcID", "Result_Set.ESrvc_Result.Auth_Result_Set.Row_Count", ...assignment.map(key => `Result_Set.ESrvc_Result.Auth_Result_Set.Row.${key}`)],
  tpauthinfo: [
    "Result_Set.ESrvc_Row_Count", "Result_Set.ESrvc_Result.CPESrvcID", "Result_Set.ESrvc_Result.Auth_Set.ENT_ROW_COUNT",
    "Result_Set.ESrvc_Result.Auth_Set.TP_Auth.CP_Clnt_ID", "Result_Set.ESrvc_Result.Auth_Set.TP_Auth.CP_ClntEnt_TYPE",
    "Result_Set.ESrvc_Result.Auth_Set.TP_Auth.Auth_Result_Set.Row_Count",
    ...thirdPartyAssignment.map(key => `Result_Set.ESrvc_Result.Auth_Set.TP_Auth.Auth_Result_Set.Row.${key}`),
  ],
};
const isScalar = value => value === null || ["string", "number", "boolean"].includes(typeof value);
const scalarClaim = data => {
  if (data === undefined || data === null) return null;
  if (isScalar(data)) return data;
  if (Array.isArray(data)) return null;
  const keys = ["value", "code", "desc"].filter(key => Object.prototype.hasOwnProperty.call(data, key));
  return keys.length ? Object.fromEntries(keys.map(key => [key, isScalar(data[key]) ? data[key] : null])) : null;
};

export function projectBusinessFields(data, paths, prefix = "", existingOnly = false) {
  if (data?.unavailable === true) return { unavailable: true };
  if (String(data?.source) === "3") return { source: "3" };
  if (Array.isArray(data)) return paths.some(parts => parts.length === 0) ? null : data.map(record => projectBusinessFields(record, paths, prefix, existingOnly));
  if (paths.some(parts => parts.length === 0)) {
    const allowed = groupedScopeFields[prefix];
    return allowed ? projectBusinessFields(data, allowed.map(path => path.split(".")), prefix, true) : scalarClaim(data);
  }
  if (data === null || data === undefined) return null;
  const result = {};
  for (const key of [...new Set(paths.map(parts => parts[0]))]) {
    if (existingOnly && !Object.prototype.hasOwnProperty.call(data, key)) continue;
    result[key] = projectBusinessFields(data?.[key], paths.filter(parts => parts[0] === key).map(parts => parts.slice(1)), prefix ? `${prefix}.${key}` : key, existingOnly);
  }
  return result;
}

export const scopeForDisplayPath = path => requestedScopes.find(scope => path === scope || path.startsWith(`${scope}.`));
export const scopesUnderDisplayPath = path => requestedScopes.filter(scope => scope === path || scope.startsWith(`${path}.`) || path.startsWith(`${scope}.`));
